import { Box, CircularProgress } from "@mui/material";

/** Content-level loading placeholder: centered spinner filling the layout frame. */
export default function LoadingScreen() {
    return (
        <Box
            sx={{
                minHeight: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <CircularProgress />
        </Box>
    );
}
